import './PrintPage.scss';

import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@/common/components/atoms/Button/Button';
import print from '@/common/helpers/print';
import { ReactComponent as PrintIcon } from '@/ebat/assets/icons/print.svg';
import { PRINT_PAGE_PARAMS } from '@/ebat/constants';

const PrintPage = () => {
  const { t } = useTranslation();

  const handlePrint = (param) => {
    document.body.classList.remove(...Object.values(PRINT_PAGE_PARAMS));
    document.body.classList.add(param);

    print();
  };

  return (
    <div className="print-page" data-qa-id="modal-print-page">
      <h1 className="rs-modal-title">
        {t('ebat:entities:product.print_page.title')}
      </h1>
      <div className="print-page__content">
        <ul className="print-page__list">
          {Object.keys(PRINT_PAGE_PARAMS).map((param) => (
            <li key={`price-${param}`} className="price">
              <div className="price__label">
                {t(`ebat:entities:product.print_page.params.${param}`)}
              </div>
              <div className="price__action">
                <Button
                  buttonSize="medium"
                  onClick={() => handlePrint(PRINT_PAGE_PARAMS[param])}
                  variant="primary"
                  withIcon
                >
                  <PrintIcon className="button__icon" />
                </Button>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default PrintPage;
